"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chars = {
    '&amp;': '&',
    '&quot;': '"',
    '&#39;': '\'',
    '&lt;': '<',
    '&gt;': '>'
};
const unescapeRegex = new RegExp('(' + Object.keys(chars).join('|') + ')', 'g');
const values = Object.keys(chars).map((key) => chars[key]);
const escapeRegex = new RegExp('(' + values.join('|') + ')', 'g');
/**
 * Escape special characters in the given string of html.
 *
 * @param  {String} html
 * @return {String}
 */
function escape(html) {
    if (!html) {
        return '';
    }
    return String(html).replace(escapeRegex, (match) => {
        for (var key in chars) {
            if (chars.hasOwnProperty(key) && chars[key] === match) {
                return key;
            }
        }
        return match;
    });
}
exports.escape = escape;
/**
 * Unescape special characters in the given string of html.
 *
 * @param  {String} html
 * @return {String}
 */
function unescape(html) {
    if (!html) {
        return '';
    }
    return String(html).replace(unescapeRegex, function (match) {
        return chars[match];
    });
}
exports.unescape = unescape;
/**
 * Downloads the image
 * @param url url of the image that needs to be downloaded
 */
function loadImage(url) {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = url;
        image.onload = () => resolve(image);
        image.onerror = reject;
    });
}
exports.loadImage = loadImage;
function isChildOf(parent, child) {
    var node = child.parentNode;
    while (node !== null) {
        if (node === parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}
exports.isChildOf = isChildOf;
function isSelectionWithin(parent) {
    if (!parent) {
        return false;
    }
    const selection = window.getSelection();
    if (selection === null || selection.rangeCount === 0) {
        return false;
    }
    const selectedRange = selection.getRangeAt(0);
    const target = (selectedRange.startContainer.nodeType === 3 ?
        selectedRange.startContainer.parentElement :
        selectedRange.startContainer);
    if (target === null) {
        return false;
    }
    return isChildOf(parent, target);
}
exports.isSelectionWithin = isSelectionWithin;
function createFocusTracker(options) {
    let timer;
    let stopped = true;
    let hasFocus = false;
    function schedule() {
        if (stopped) {
            return;
        }
        timer = setTimeout(() => {
            if (options.check(document.activeElement)) {
                hasFocus = true;
                schedule();
                return;
            }
            if (hasFocus) {
                options.onLostFocus();
                stopped = true;
                hasFocus = false;
            }
            schedule();
        }, 1000);
    }
    return {
        hasFocus() {
            return hasFocus;
        },
        start() {
            this.stop();
            hasFocus = false;
            stopped = false;
            schedule();
        },
        stop() {
            stopped = true;
            clearTimeout(timer);
        }
    };
}
exports.createFocusTracker = createFocusTracker;
/**
 * Loads a script dynamically on the fly.
 * @param path path of the script to be loaded
 */
function loadScript(path) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = path;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
}
exports.loadScript = loadScript;
function ensureStyleTag(id) {
    let style = document.getElementById(id);
    if (!style) {
        style = document.createElement('style');
        style.id = id;
        style.type = 'text/css';
        if (document && document.head) {
            document.head.appendChild(style);
        }
    }
    return style;
}
function addStylesToPage(id, css) {
    let style = ensureStyleTag(id);
    style.innerHTML = css;
    return style;
}
exports.addStylesToPage = addStylesToPage;
function createStylesController(id) {
    let style = ensureStyleTag(id);
    let removed = false;
    return {
        update(css) {
            if (removed) {
                return;
            }
            style.innerHTML = css;
        },
        remove() {
            if (removed) {
                return;
            }
            if (document && document.head) {
                document.head.removeChild(style);
                removed = true;
            }
        }
    };
}
exports.createStylesController = createStylesController;
let proxy;
function copyTextToClipboard(text) {
    if (!proxy) {
        proxy = document.createElement('input');
    }
    proxy.value = text;
    proxy.hidden = false;
    document.body.appendChild(proxy);
    proxy.select();
    document.execCommand('copy');
    document.body.removeChild(proxy);
}
exports.copyTextToClipboard = copyTextToClipboard;
//# sourceMappingURL=html.js.map